export default "__VITE_ASSET__7e91f1ab__"